import {
    StepOne,
    StepFive,
    StepFour,
    StepThree,
    StepSix,
    StepTwo,
} from "./components/Icons";

export const WORK_STEPS_DATA = [
    { title: "Звоните нам", step: 1, icon: StepOne },
    {
        title: "Предварительно расчитываем стоимость",
        step: 2,
        icon: StepTwo,
    },
    {
        title: "Замерщик приезжает к вам",
        step: 3,
        icon: StepThree,
    },
    {
        title: "Согласовываем заказ",
        step: 4,
        icon: StepFour,
    },

    {
        title: "Изготавливается заказ",
        step: 5,
        icon: StepFive,
    },

    {
        title: "Доставляем и монтируем заказ",
        step: 6,
        icon: StepSix,
    },
];
